// Seeded starfield, same soft radial-gradient technique as the marketing hero
// so dots read as stars, not dead pixels. Sparse + low opacity to stay clean.
const STARS = [
  { t: 8, l: 12, s: 1, o: 0.18, tw: null },
  { t: 14, l: 28, s: 1, o: 0.12, tw: 1.2 },
  { t: 6, l: 47, s: 2, o: 0.16, tw: null },
  { t: 11, l: 66, s: 1, o: 0.2, tw: null },
  { t: 7, l: 82, s: 1, o: 0.12, tw: null },
  { t: 19, l: 91, s: 1, o: 0.16, tw: null },
  { t: 24, l: 7, s: 1, o: 0.14, tw: null },
  { t: 30, l: 22, s: 1, o: 0.1, tw: 2.6 },
  { t: 34, l: 73, s: 2, o: 0.14, tw: null },
  { t: 28, l: 88, s: 1, o: 0.18, tw: null },
  { t: 44, l: 5, s: 1, o: 0.12, tw: null },
  { t: 52, l: 17, s: 1, o: 0.16, tw: null },
  { t: 60, l: 9, s: 1, o: 0.1, tw: 3.4 },
  { t: 66, l: 26, s: 1, o: 0.14, tw: null },
  { t: 71, l: 84, s: 1, o: 0.12, tw: null },
  { t: 64, l: 94, s: 2, o: 0.16, tw: null },
  { t: 78, l: 14, s: 1, o: 0.14, tw: null },
  { t: 83, l: 32, s: 1, o: 0.1, tw: null },
  { t: 88, l: 71, s: 1, o: 0.16, tw: 1.9 },
  { t: 92, l: 88, s: 1, o: 0.12, tw: null },
  { t: 40, l: 60, s: 1, o: 0.12, tw: null },
  { t: 48, l: 79, s: 1, o: 0.14, tw: null },
];

export default function AuthShell({ children }) {
  return (
    <div className="min-h-screen bg-[#020617] text-white relative overflow-hidden font-sans">
      <style>{`
        @keyframes authTwinkle {
          0%, 100% { opacity: 0.45; }
          50% { opacity: 0.1; }
        }
        .auth-star-tw { animation: authTwinkle 5.5s ease-in-out infinite; }
        @media (prefers-reduced-motion: reduce) {
          .auth-star-tw { animation: none !important; }
        }
      `}</style>

      {/* Background — indigo/blue glow orbs + sparse starfield (hero palette) */}
      <div aria-hidden className="pointer-events-none absolute inset-0 overflow-hidden">
        <div className="absolute -top-40 left-1/2 -translate-x-1/2 w-[700px] h-[500px] bg-indigo-600/15 blur-[140px] rounded-full" />
        <div className="absolute bottom-0 left-1/4 w-[420px] h-[360px] bg-blue-600/10 blur-[130px] rounded-full" />

        {STARS.map((star, i) => {
          const size = star.s === 2 ? 6 : 3.5;
          const core = star.s === 2 ? "rgba(199,210,254,0.9)" : "rgba(255,255,255,0.85)";
          return (
            <span
              key={i}
              className={star.tw !== null ? "auth-star-tw" : undefined}
              style={{
                position: "absolute",
                top: `${star.t}%`,
                left: `${star.l}%`,
                width: size,
                height: size,
                background: `radial-gradient(circle, ${core} 0%, rgba(255,255,255,0) 65%)`,
                opacity: Math.min(star.o + 0.22, 0.55),
                animationDelay: star.tw !== null ? `${star.tw}s` : undefined,
              }}
            />
          );
        })}
      </div>

      {/* Foreground content — the brand mark now lives inside each panel (AuthBrand) */}
      <div className="relative z-10 min-h-screen flex flex-col items-center justify-center px-6 py-10">
        {children}

        {/* Footer links */}
        <div className="mt-8 flex flex-col items-center gap-2 text-[11.5px] text-slate-500">
          <div className="flex items-center justify-center gap-3">
            <a href="https://whiteintel.io" className="hover:text-slate-300 transition-colors" target="_blank" rel="noreferrer">Home</a>
            <span className="text-slate-700">·</span>
            <a href="https://knowledge.whiteintel.io/" className="hover:text-slate-300 transition-colors" target="_blank" rel="noreferrer">Knowledge Center</a>
            <span className="text-slate-700">·</span>
            <a href="https://whiteintel.io/terms" className="hover:text-slate-300 transition-colors" target="_blank" rel="noreferrer">Terms</a>
            <span className="text-slate-700">·</span>
            <a href="https://whiteintel.io/privacy" className="hover:text-slate-300 transition-colors" target="_blank" rel="noreferrer">Privacy</a>
          </div>
          <div className="text-[11px] text-slate-600">v4.0.5 © 2026 Whiteintel</div>
        </div>
      </div>
    </div>
  );
}
